import { defineComponent as _defineComponent } from 'vue'
import * as Components from '.';
import FormFieldErrors from './FormFieldErrors.vue';
import { isEqual } from 'lodash';
import { computed, ref } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FormModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormField',
  props: makeUseFormElementProps<FormModel>(),
  emits: makeUseFormElementEmits(),
  setup(__props, { expose, emit }) {

const props = __props;





const formElement = useFormElement({
  emit,
  props,
});

const {
  fieldClass,
  fieldErrorsShown,
  fieldType,
  fieldTitle,
  htmlTitle,
  showRequired,
  tooltipComponent,
  fieldTitleTooltip,
} = useBaseFieldValues(formElement);

const { modelStateRef, model, field, getSlotName, emitFormEvent, setValue } = formElement;

const item = ref<Vue>();

const hideErrorMessages = modelStateRef('hideErrorMessages', false, true);

const titleClass = modelStateRef('titleClass', null);

const clearable = modelStateRef('clearable', false);

const clearValue = modelStateRef('clearValue', null);

const showClear = computed(() => {
  return (
    clearable.value &&
    field.value.$model !== undefined &&
    field.value.$model !== null &&
    !isEqual(field.value.$model, clearValue.value)
  );
});

function triggerFieldAction(path: string, action: any) {
  const child = (item.value || {}) as any;
  if (child.triggerFieldAction) {
    child.triggerFieldAction(path, action);
  }
}

function clearField() {
  setValue(clearValue.value, true);
}

const fieldEl = computed(() => {
  const key = fieldType.value[0].toUpperCase() + fieldType.value.substring(1) + 'FormField';
  return (Components as Record<string, Object>)[key];
});

expose({
  triggerFieldAction,
});

return { __sfc: true,props, emit, formElement, fieldClass, fieldErrorsShown, fieldType, fieldTitle, htmlTitle, showRequired, tooltipComponent, fieldTitleTooltip, modelStateRef, model, field, getSlotName, emitFormEvent, setValue, item, hideErrorMessages, titleClass, clearable, clearValue, showClear, triggerFieldAction, clearField, fieldEl, FormFieldErrors }
}

})